import { useEffect, useState } from 'react'
import { onDCEvent } from '../backend-com'
import { permilleToPercent } from '../utils/downloadProgress'

/**
 * Latest download progress (0-100) for a message whose `downloadState`
 * is `'InProgress'`, driven by the core's `DownloadProgress` event.
 * Returns `null` until the first event for this message arrives.
 */
export function useDownloadProgress(
  accountId: number,
  messageId: number,
  isDownloading: boolean
): number | null {
  const [percent, setPercent] = useState<number | null>(null)

  useEffect(() => {
    if (!isDownloading) {
      return
    }
    return onDCEvent(accountId, 'DownloadProgress', ({ msgId, permille }) => {
      if (msgId === messageId) {
        setPercent(permilleToPercent(permille))
      }
    })
  }, [accountId, messageId, isDownloading])

  // A stale value from an earlier download attempt is masked instead of
  // reset via setState in the effect body, which eslint forbids.
  return isDownloading ? percent : null
}
